<template>
  <div class="order-management">
    <!-- 页面加载状态 -->
    <div v-if="!pageReady" class="page-loading-container">
      <div class="page-loading-content">
        <div class="page-loading-spinner">
          <i class="el-icon-loading"></i>
        </div>
        <p class="page-loading-title">正在初始化订单管理...</p>
        <p class="page-loading-detail">正在获取订单数据，请稍候...</p>
      </div>
    </div>

    <!-- 主要内容 -->
    <div v-else>
      <!-- Tab分页导航 -->
      <div class="tabs-header">
        <div style="display: flex; align-items: center">
          <el-tabs v-model="activeTab" type="card" class="main-tabs">
            <el-tab-pane label="订单列表" name="orders">
              <!-- 使用订单列表组件 -->
            </el-tab-pane>

            <el-tab-pane label="预下单列表" name="preOrders"> </el-tab-pane>

            <el-tab-pane label="客户信息" name="customers"> </el-tab-pane>

            <el-tab-pane label="订单绑定" name="binding"> </el-tab-pane>
          </el-tabs>

          <!-- <div
            class="tab-actions"
            style="margin-top: -20px; margin-right: 10px"
          >
            <el-button
              type="primary"
              size="small"
              @click="dialogVisible = true"
            >
              为客户下单
            </el-button>
          </div> -->
          <div class="tab-actions" style="margin-top: -20px">
            <el-button
              v-if="activeTab == 'orders'"
              type="primary"
              size="small"
              :loading="loading"
              @click="loadOrderList"
              icon="el-icon-refresh"
            >
              刷新
            </el-button>
            <el-button
              v-else-if="activeTab == 'preOrders'"
              type="primary"
              size="small"
              :loading="preOrderLoading"
              @click="loadPreOrderList"
              icon="el-icon-refresh"
            >
              刷新
            </el-button>
          </div>
        </div>
        <div style="height: 22px"></div>
        <OrderList
          v-if="activeTab == 'orders'"
          :orders="orderList"
          :loading="loading"
          :pagination="pagination"
          :show-pagination="true"
          @refresh="loadOrderList"
          @load-logistics="handleLogisticsClick"
          @toggle-detail="lookinfo"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <div v-if="activeTab == 'preOrders'" class="preorder-container">
          <div v-if="preOrderLoading" class="preorder-loading">
            <i class="el-icon-loading"></i>
            <p>正在加载预订单...</p>
          </div>
          <div v-else-if="preOrderList.length === 0" class="preorder-empty">
            <el-empty description="暂无预订单数据">
              <el-button type="primary" @click="loadPreOrderList"
                >重新加载</el-button
              >
            </el-empty>
          </div>
          <div v-else class="preorder-list">
            <div
              v-for="preOrder in preOrderList"
              :key="preOrder.id"
              class="order-card preorder-card"
            >
              <div class="order-header">
                <span class="order-number"> 预订单 </span>
                <el-tag
                  size="mini"
                  effect="plain"
                  :type="
                    preOrder.status == 0
                      ? 'info'
                      : preOrder.status == 1
                      ? 'success'
                      : 'danger'
                  "
                >
                  {{
                    preOrder.status == 0
                      ? "未执行"
                      : preOrder.status == 1
                      ? "已执行"
                      : "执行失败"
                  }}
                </el-tag>
              </div>
              <div class="order-content">
                <div class="preorder-card-content">
                  <div class="product-info">
                    <div class="product-image">
                      <img
                        v-if="getPreOrderImage(preOrder)"
                        :src="getPreOrderImage(preOrder)"
                        alt="商品图片"
                        @error="handlePreOrderImageError($event)"
                      />
                      <div v-else class="preorder-goods-placeholder">
                        无图片
                      </div>
                    </div>
                    <div class="product-details">
                      <div class="product-name">
                        {{ preOrder.goodsTitle || "未命名商品" }}
                      </div>
                      <div v-if="preOrder.goodsSubTitle" class="product-subtitle">
                        {{ preOrder.goodsSubTitle }}
                      </div>
                      <div class="product-sku">
                        <span class="label">SKU：</span>
                        <span class="value">{{ preOrder.sku }}</span>
                        <el-button
                          type="text"
                          size="mini"
                          @click="copyText(preOrder.sku)"
                          class="copy-btn-inline"
                          title="复制"
                        >
                          <i class="el-icon-document-copy"></i>
                        </el-button>
                      </div>
                      <div class="product-sku">
                        <span class="label">订单创建时间：</span>
                        <span class="value">{{
                          preOrder.createTime || "-"
                        }}</span>
                      </div>
                      <div class="product-sku">
                        <span class="label">预设下单时间：</span>
                        <span class="value">{{
                          preOrder.orderTime || "-"
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="preorder-info">
                    <div class="info-row">
                      <span class="label">客户信息：</span>
                      <div class="value">
                        {{ preOrder.idCardName || "未知客户" }} /
                        {{ preOrder.phone || "-" }}
                      </div>
                    </div>
                    <div class="info-row">
                      <span class="label">收货地址：</span>
                      <div class="value">
                        {{ formatPreOrderAddress(preOrder) }}
                      </div>
                    </div>
                    <div class="info-row">
                      <span class="label">执行备注：</span>
                      <div class="value">
                        {{ preOrder.executeRemark }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="preorder-actions">
                  <el-button
                    v-if="preOrder.status != 1"
                    type="primary"
                    size="mini"
                    plain
                    @click="openPreOrderEdit(preOrder)"
                  >
                    编辑预订单
                  </el-button>
                </div>
              </div>
            </div>
            <div class="pagination-container">
              <el-pagination
                @size-change="handlePreOrderSizeChange"
                @current-change="handlePreOrderCurrentChange"
                :current-page="preOrderPagination.pageNum"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="preOrderPagination.pageSize"
                layout="sizes, prev, pager, next"
                :total="preOrderPagination.total"
              />
            </div>
          </div>
        </div>
        <!-- <CustomerList
          v-if="activeTab == 'customers'"
          corp-id="ww2e7ef17a92a94bce"
          qw-user-id="wmYz8TLgAACtKePWIprb4g7-Dy5Tlsqg"
          @view-customer="handleViewCustomer"
        /> -->
        <CustomerList
          v-if="activeTab == 'customers'"
          :corp-id="localWechatCorpId"
          :qw-user-id="getFrontendUserId()"
          @view-customer="handleViewCustomer"
        />
        <OrderBinding
          v-if="activeTab == 'binding'"
          @binding-success="handleBindingSuccess"
          :default-corp-id="localWechatCorpId"
          :default-ser-user-id="getServerUserId()"
          :default-external-user-id="getFrontendUserId()"
          ref="orderBinding"
        />
      </div>
      <el-dialog
        title="编辑预订单"
        :visible.sync="preOrderEditDialogVisible"
        width="480px"
        @close="resetPreOrderEditForm"
      >
        <el-form :model="preOrderEditForm" label-width="120px">
          <el-form-item label="预设下单时间" required>
            <el-date-picker
              v-model="preOrderEditForm.orderTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择预设下单时间"
              :picker-options="preOrderDatePickerOptions"
              style="width: 100%"
              clearable
            />
          </el-form-item>
          <el-form-item label="预订单状态">
            <el-select
              v-model="preOrderEditForm.orderStatus"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option label="未执行" :value="0" />
              <el-option label="已执行" :value="1" />
              <el-option label="执行失败" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="执行备注">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入执行备注"
              v-model="textarea"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="preOrderEditDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            :loading="preOrderEditSubmitting"
            @click="submitPreOrderUpdate"
            >保存</el-button
          >
        </span>
      </el-dialog>
      <!-- 主要内容结束 -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getOrderList,
  desensitization,
  getLogisticsInfo,
  getPreOrderList,
  updatePreOrder,
  getCustomerInfo,
  extractCustomerNo,
  clearCustomerInfoCache,
} from "@/api/wechat";
import { BASE_URL } from "@/utils/request";
import { getOrderStatusName } from "@/utils/orderStatus";
import OrderBinding from "@/components/OrderBinding.vue";
import CustomerList from "@/components/CustomerList.vue";
import OrderList from "@/components/OrderList.vue";

export default {
  name: "OrderManagement",
  components: {
    OrderBinding,
    CustomerList,
    OrderList,
  },
  computed: {
    ...mapGetters(["isWechatReady", "wechatCorpId", "wechatUserId"]),
    // 优先从本地存储获取corpId
    localWechatCorpId() {
      const localCorpId = localStorage.getItem("wechat_corpId");
      if (localCorpId) {
        return localCorpId;
      }
      // 备用：从store获取
      return this.wechatCorpId;
    },
  },
  data() {
    return {
      textarea:'',
      activeTab: "orders",
      loading: false,
      pageReady: false, // 页面是否准备就绪（订单列表加载完成后）
      orderList: [],
      searchForm: {
        endTime: null,
      },
      pagination: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      dataList: [],
      showApiInfo: true,
      currentApiInfo: {
        url: "",
        method: "",
        params: {},
        timestamp: "",
      },
      preOrderLoading: false,
      preOrdersLoaded: false,
      preOrderList: [],
      preOrderPagination: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      preOrderEditDialogVisible: false,
      preOrderEditForm: {
        orderTime: "",
        orderStatus: null,
      },
      preOrderEditing: null,
      preOrderEditSubmitting: false,
      preOrderStatusOptions: [],
      preOrderDatePickerOptions: {
        disabledDate(time) {
          const startOfToday = new Date();
          startOfToday.setHours(0, 0, 0, 0);
          return time.getTime() < startOfToday.getTime();
        },
      },
    };
  },
  watch: {
    activeTab(newVal) {
      if (newVal === "preOrders" && !this.preOrdersLoaded) {
        this.loadPreOrderList();
      }
    },
    isWechatReady(ready) {
      if (ready && this.activeTab === "orders" && this.orderList.length === 0) {
        this.loadOrderList();
      }
    },
  },
  mounted() {
    const localParams = this.getWechatParamsFromLocal();
    console.log("订单页面挂载时的本地存储参数:", localParams);
    this.loadOrderList();
  },
  methods: {
    // 从本地存储获取企业微信参数
    getWechatParamsFromLocal() {
      try {
        const localCorpId = localStorage.getItem("wechat_corpId");
        const localServerUserId = localStorage.getItem("wechat_serverUserId");
        const localExternalUserId = localStorage.getItem(
          "wechat_externalUserId"
        );
        const timestamp = localStorage.getItem("wechat_params_timestamp");

        console.log("从本地存储获取企业微信参数:", {
          localCorpId,
          localServerUserId,
          localExternalUserId,
          timestamp: timestamp
            ? new Date(parseInt(timestamp)).toLocaleString()
            : "无",
        });

        return {
          corpId: localCorpId,
          serverUserId: localServerUserId,
          externalUserId: localExternalUserId,
          timestamp: timestamp,
        };
      } catch (error) {
        console.error("从本地存储获取企业微信参数失败:", error);
        return {};
      }
    },

    // 处理物流信息点击
    async handleLogisticsClick(order) {
      // 如果已经有物流信息，不重复请求
      if (order.logisticsInfo) {
        return;
      }

      try {
        const response = await getLogisticsInfo(order.orderNo);

        if (response && response.code === 200 && response.data) {
          // 将物流信息添加到订单数据中
          this.$set(order, "logisticsInfo", {
            productionNumber: response.data.prodCardNum || "",
            logisticsCompany: response.data.trackingCompany || "",
            trackingNumber: response.data.trackingNo || "",
          });
        } else {
          // 如果没有数据，设置空的物流信息
          this.$set(order, "logisticsInfo", {
            productionNumber: "",
            logisticsCompany: "",
            trackingNumber: "",
          });
        }
      } catch (error) {
        console.error("获取物流信息失败:", error);
        // 设置空的物流信息以避免重复请求
        this.$set(order, "logisticsInfo", {
          productionNumber: "",
          logisticsCompany: "",
          trackingNumber: "",
        });
      }
    },

    formatPreOrderAddress(row) {
      const parts = [row.province, row.city, row.town, row.address].filter(
        Boolean
      );
      return parts.length > 0 ? parts.join("") : "暂无地址信息";
    },

    formatPreOrderCreateTime(time) {
      if (!time) {
        return "创建时间未知";
      }
      return time;
    },

    getPreOrderImage(row) {
      if (!row) return "";
      // 优先显示缩略图，如果没有则显示主图
      const candidates = [
        row.goodsMainImgThumbnail,  // 优先使用商品缩略图（新字段）
        row.mainImgThumbnail,       // 兼容旧字段
        row.mainImg,                // 其次使用主图
        row.goodsMainImg,
        row.goodsImage,
        row.goodsImg,
        row.goods?.mainImg,
      ];
      for (const source of candidates) {
        if (!source) continue;
        if (typeof source === "string" && source.includes(",")) {
          return source.split(",")[0];
        }
        if (typeof source === "string") {
          return source;
        }
      }
      return "";
    },

    handlePreOrderImageError(event) {
      event.target.style.display = "none";
    },

    // getPreOrderStatusValue(row) {
    //   if (row.orderStatus !== undefined && row.orderStatus !== null) {
    //     return row.orderStatus;
    //   }
    //   if (row.status !== undefined && row.status !== null) {
    //     return row.status;
    //   }
    //   return null;
    // },

    getPreOrderStatusLabel(row) {
      return row.orderStatusName || row.statusName || "未知状态";
    },

    // buildPreOrderStatusOptions(list = []) {
    //   const optionMap = new Map();
    //   list.forEach((item) => {
    //     const value = this.getPreOrderStatusValue(item);
    //     if (value === null || value === undefined || optionMap.has(value)) {
    //       return;
    //     }
    //     const label =
    //       item.orderStatusName || item.statusName || `状态 ${value}`;
    //     optionMap.set(value, label);
    //   });
    //   this.preOrderStatusOptions = Array.from(optionMap.entries()).map(
    //     ([value, label]) => ({
    //       value,
    //       label,
    //     })
    //   );
    // },

    async loadPreOrderList() {
      this.preOrderLoading = true;
      try {
        const { corpId, externalUserId, serverUserId } =
          await this.resolveWechatContext();

        if (!corpId || !externalUserId || !serverUserId) {
          this.preOrderList = [];
          this.preOrderPagination.total = 0;
          return;
        }

        clearCustomerInfoCache();

        const customerRes = await getCustomerInfo({
          corpId,
          customerUserId: externalUserId,
          serUserId: serverUserId,
        });

        let customerNo = "";
        if (customerRes && customerRes.code === 200 && customerRes.data) {
          customerNo = customerRes.data.customerNo;
        }

        if (!customerNo) {
          this.preOrderList = [];
          this.preOrderPagination.total = 0;
          return;
        }

        const response = await getPreOrderList(customerNo);
        let list = [];
        if (response && response.rows) {
          list = response.rows;
          this.preOrderPagination.total = response.total || 0;
        } else if (Array.isArray(response)) {
          list = response;
          this.preOrderPagination.total = response.length;
        }
        this.preOrderList = list;
        this.preOrdersLoaded = true;
      } catch (error) {
        console.error("获取预订单列表失败:", error);
        this.$message.error(`获取预订单失败: ${error.message}`);
        this.preOrderList = [];
        this.preOrderPagination.total = 0;
      } finally {
        this.preOrderLoading = false;
      }
    },

    handlePreOrderSizeChange(val) {
      this.preOrderPagination.pageSize = val;
      this.preOrderPagination.pageNum = 1;
      this.loadPreOrderList();
    },

    handlePreOrderCurrentChange(val) {
      this.preOrderPagination.pageNum = val;
      this.loadPreOrderList();
    },

    openPreOrderEdit(row) {
      this.preOrderEditing = row;
      this.textarea = row.executeRemark || "";
      this.preOrderEditForm = {
        orderTime: row.orderTime || "",
        orderStatus: row.status || 0,
      };
      this.preOrderEditDialogVisible = true;
    },

    resetPreOrderEditForm() {
      this.preOrderEditing = null;
      this.preOrderEditForm = {
        orderTime: "",
        orderStatus: null,
      };
    },

    async submitPreOrderUpdate() {
      if (!this.preOrderEditing) {
        return;
      }
      if (!this.preOrderEditForm.orderTime) {
        this.$message.error("请选择预设下单时间");
        return;
      }
      this.preOrderEditSubmitting = true;
      try {
        const payload = {
          id: this.preOrderEditing.id,
          sku: this.preOrderEditing.goodsSku,
          serSysUserId: this.preOrderEditing.serSysUserId,
          paymentId: this.preOrderEditing.paymentId,
          pctIds: this.preOrderEditing.pctIds,
          idCardNo: this.preOrderEditing.idCardNo,
          idCardName: this.preOrderEditing.idCardName,
          phone: this.preOrderEditing.phone,
          province: this.preOrderEditing.province,
          city: this.preOrderEditing.city,
          town: this.preOrderEditing.town,
          address: this.preOrderEditing.address,
          executeRemark: this.textarea,
          orderTime: this.preOrderEditForm.orderTime,
        };
        if (
          this.preOrderEditForm.orderStatus !== null &&
          this.preOrderEditForm.orderStatus !== undefined &&
          this.preOrderEditForm.orderStatus !== ""
        ) {
          payload.status = this.preOrderEditForm.orderStatus;
        }
        await updatePreOrder(payload);
        this.$message.success("预订单更新成功");
        this.preOrderEditDialogVisible = false;
        this.resetPreOrderEditForm();
        this.loadPreOrderList();
      } catch (error) {
        console.error("更新预订单失败:", error);
        this.$message.error(`更新预订单失败: ${error.message}`);
      } finally {
        this.preOrderEditSubmitting = false;
      }
    },
    //查看详情
    lookinfo(Val) {
      if (this.dataList.length == 0) {
        this.dataList = JSON.parse(JSON.stringify(this.orderList));
      }
      if (Val.ditalStatus == 0) {
        desensitization(Val.orderNo).then((res) => {
          if (res.code == 200) {
            this.orderList.forEach((item) => {
              if (item.orderId == Val.orderId) {
                item.ditalStatus = "1";
                item.idCardName = res.data.idCardName;
                item.idCardNo = res.data.idCardNo;
                item.city = res.data.city;
                item.address = res.data.address;
                item.province = res.data.province;
                item.town = res.data.town;
                item.phone = res.data.phone;
              }
            });
          }
        });
      } else {
        const newData = this.dataList.find((i) => i.orderId === Val.orderId);
        this.orderList.forEach((item) => {
          if (item.orderId == Val.orderId) {
            item.ditalStatus = "0";
            item.idCardName = newData.idCardName;
            item.idCardNo = newData.idCardNo;
            item.city = newData.city;
            item.address = newData.address;
            item.province = newData.province;
            item.town = newData.town;
            item.phone = newData.phone;
          }
        });
      }
    },
    // 获取服务端用户ID - 优先从本地存储获取
    getServerUserId() {
      // 优先从本地存储获取
      const localServerUserId = localStorage.getItem("wechat_serverUserId");
      if (localServerUserId) {
        console.log("从本地存储获取服务端用户ID:", localServerUserId);
        return localServerUserId;
      }

      // 备用：从store获取
      const serverUserId =
        this.$store.state.wechat?.debugInfo?.getUserIdApi?.response;
      console.log(
        "从store获取服务端用户ID:",
        serverUserId,
        "类型:",
        typeof serverUserId
      );
      return serverUserId || null;
    },

    // 获取前端用户ID（外部联系人ID）- 优先从本地存储获取
    getFrontendUserId() {
      // 优先从本地存储获取
      const localExternalUserId = localStorage.getItem("wechat_externalUserId");
      if (localExternalUserId) {
        console.log("从本地存储获取前端用户ID:", localExternalUserId);
        return localExternalUserId;
      }

      // 备用：从store获取
      const frontendUserInfo = this.$store.state.wechat.userInfo?.frontend;
      console.log("前端用户信息:", frontendUserInfo);

      if (frontendUserInfo) {
        const possibleFields = ["userId", "UserId", "userid", "user_id", "id"];
        for (const field of possibleFields) {
          if (frontendUserInfo[field]) {
            console.log(
              `找到前端用户ID字段: ${field} = ${frontendUserInfo[field]}`
            );
            return frontendUserInfo[field];
          }
        }
      }

      // 尝试从userInfo.externalUserId获取
      const externalUserId = this.$store.state.wechat.userInfo?.externalUserId;
      if (externalUserId) {
        console.log("从externalUserId获取前端用户ID:", externalUserId);
        return externalUserId;
      }

      console.log("未找到前端用户ID");
      return null;
    },

    async waitForWechatContext(timeout = 8000, interval = 300) {
      const startTime = Date.now();

      return new Promise((resolve) => {
        const check = () => {
          const context = {
            corpId: this.localWechatCorpId,
            externalUserId: this.getFrontendUserId(),
            serverUserId: this.getServerUserId(),
          };

          if (context.corpId && context.externalUserId && context.serverUserId) {
            resolve(context);
            return;
          }

          if (Date.now() - startTime >= timeout) {
            resolve(context);
            return;
          }

          setTimeout(check, interval);
        };

        check();
      });
    },

    async resolveWechatContext() {
      const context = await this.waitForWechatContext();

      return {
        corpId: context.corpId || this.localWechatCorpId,
        externalUserId: context.externalUserId || this.getFrontendUserId(),
        serverUserId: context.serverUserId || this.getServerUserId(),
      };
    },

    // 加载订单列表
    async loadOrderList() {
      this.loading = true;
      try {
        const { corpId, externalUserId, serverUserId } =
          await this.resolveWechatContext();

        if (!corpId || !externalUserId || !serverUserId) {
          this.$message.warning("企业微信客户信息仍在初始化，请稍后刷新重试");
          this.orderList = [];
          this.pagination.total = 0;
          if (!this.pageReady) {
            this.pageReady = true;
          }
          return;
        }

        clearCustomerInfoCache();

        const customerRes = await getCustomerInfo({
          corpId,
          customerUserId: externalUserId,
          serUserId: serverUserId,
        });

        const customerNo = extractCustomerNo(customerRes);

        if (!customerNo) {
          this.$message.warning("未获取到客户编号");
          this.orderList = [];
          this.pagination.total = 0;
          return;
        }

        const response = await getOrderList(
          customerNo,
          this.pagination.pageNum,
          this.pagination.pageSize,
          externalUserId,
          corpId,
          serverUserId
        );
        if (response && response.rows) {
          this.orderList = response.rows.map(order => ({
            ...order,
            orderStatusName: order.orderStatusName || getOrderStatusName(order.orderStatus),
            ditalStatus: "0"
          }));
          this.pagination.total = response.total || 0;
        } else if (Array.isArray(response)) {
          this.orderList = response.map(item => ({
            ...item,
            orderStatusName: item.orderStatusName || getOrderStatusName(item.orderStatus),
            ditalStatus: "0"
          }));
          this.pagination.total = response.length;
        } else {
          this.orderList = [];
          this.pagination.total = 0;
        }

        // 首次加载成功后，设置页面为就绪状态
        if (!this.pageReady) {
          this.pageReady = true;
        }
      } catch (error) {
        console.error("获取订单列表失败:", error);
        this.$message.error(`获取订单列表失败: ${error.message}`);
        this.orderList = [];
        this.pagination.total = 0;

        // 即使失败也要显示页面，避免一直加载
        if (!this.pageReady) {
          this.pageReady = true;
        }
      } finally {
        this.loading = false;
      }
    },

    // 重置搜索
    resetSearch() {
      this.searchForm.endTime = null;
      this.pagination.pageNum = 1;
      this.loadOrderList();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.loadOrderList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.loadOrderList();
    },

    // 处理订单绑定成功
    handleBindingSuccess(response) {
      console.log("订单绑定成功:", response);
      // 可以在这里刷新订单列表或执行其他操作
      if (this.activeTab === "orders") {
        this.loadOrderList();
      }
    },

    // 处理查看客户详情
    handleViewCustomer(customer) {
      console.log("查看客户详情:", customer);
      // 这里可以打开客户详情弹窗或执行其他操作
      // this.$message.info(`查看客户: ${customer.name || customer.userName || '未知客户'}`);
    },

    // 打开外部链接
    // openExternalLink() {
    //   const url = "https://huitongxin.cn/orderManage/orderManage/index";
    //   try {
    //     // 在新窗口中打开链接
    //     window.open(url, "_blank");
    //     this.$message.success("正在打开汇通信网站...");
    //   } catch (error) {
    //     console.error("打开外部链接失败:", error);
    //     this.$message.error("打开链接失败，请手动访问：" + url);
    //   }
    // },

    // 切换API信息显示
    toggleApiInfo() {
      this.showApiInfo = !this.showApiInfo;
    },

    // 更新API信息
    updateApiInfo(url, method, params) {
      this.currentApiInfo = {
        url: BASE_URL + url,
        method: method.toUpperCase(),
        params: params,
        timestamp: new Date().toLocaleString("zh-CN"),
      };
    },

    // 获取请求方法标签类型
    getMethodTagType(method) {
      const methodTypes = {
        GET: "success",
        POST: "primary",
        PUT: "warning",
        DELETE: "danger",
      };
      return methodTypes[method] || "info";
    },

    // 格式化参数显示
    formatParams(params) {
      if (!params || Object.keys(params).length === 0) {
        return "无参数";
      }
      return JSON.stringify(params, null, 2);
    },

    // 格式化URL参数显示
    formatUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const params = {};
      for (const [key, value] of urlParams.entries()) {
        params[key] = value;
      }
      return JSON.stringify(
        {
          currentUrl: window.location.href,
          searchParams: params,
          state: urlParams.get("state"),
          code: urlParams.get("code"),
        },
        null,
        2
      );
    },

    // 格式化Store状态显示
    formatStoreState() {
      const wechatState = this.$store.state.wechat;
      const debugInfo = {
        corpId: wechatState?.corpId,
        userId: wechatState?.userId,
        userInfo: wechatState?.userInfo,
        getUserIdApi: wechatState?.debugInfo?.getUserIdApi,
        isInitialized: wechatState?.isInitialized,
        agentId: wechatState?.agentId,
        sdkVersion: wechatState?.sdkVersion,
      };
      return JSON.stringify(debugInfo, null, 2);
    },
  },
};
</script>

<style scoped>
/* 订单管理页面 - 统一固定样式 */
.order-management {
  padding: 8px;
  max-width: 100%;
  margin: 0 auto;
  font-size: 12px;
  line-height: 1.4;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* 页面加载状态样式 */
.page-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 20px;
}

.page-loading-content {
  text-align: center;
  color: #606266;
}

.page-loading-spinner {
  margin-bottom: 8px;
}

.page-loading-spinner i {
  font-size: 22px;
  color: #409eff;
  animation: rotating 2s linear infinite;
}

.page-loading-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin: 0 0 4px 0;
}

.page-loading-detail {
  font-size: 12px;
  color: #909399;
  margin: 0;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Element UI 组件样式 */
.order-management >>> .el-tabs__item,
.order-management ::v-deep .el-tabs__item {
  font-size: 11px !important;
  padding: 0 6px !important;
  height: 26px !important;
  line-height: 26px !important;
}

.order-management >>> .el-collapse-item__header,
.order-management ::v-deep .el-collapse-item__header {
  font-size: 10px !important;
  padding: 3px 6px !important;
  height: 20px !important;
  line-height: 14px !important;
  border-bottom: 1px solid #ebeef5 !important;
  font-weight: 500 !important;
  margin: 0 !important;
  border-radius: 0 !important;
}

.order-management >>> .el-collapse-item__content,
.order-management ::v-deep .el-collapse-item__content {
  padding: 4px 6px !important;
  font-size: 9px !important;
}

.order-management >>> .el-button--mini,
.order-management ::v-deep .el-button--mini {
  font-size: 8px !important;
  padding: 1px 3px !important;
  min-height: 14px !important;
  line-height: 12px !important;
}

.order-management >>> .el-button--text,
.order-management ::v-deep .el-button--text {
  font-size: 8px !important;
  padding: 1px 2px !important;
  min-height: 14px !important;
  line-height: 12px !important;
}

.order-management >>> .el-tag,
.order-management ::v-deep .el-tag {
  font-size: 8px !important;
  padding: 0 3px !important;
  height: 14px !important;
  line-height: 12px !important;
}

.order-management >>> .el-pagination,
.order-management ::v-deep .el-pagination {
  font-size: 10px !important;
}

.order-management >>> .el-pagination .el-pager li,
.order-management ::v-deep .el-pagination .el-pager li {
  font-size: 10px !important;
  min-width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}

.order-management >>> .el-pagination .btn-prev,
.order-management >>> .el-pagination .btn-next,
.order-management ::v-deep .el-pagination .btn-prev,
.order-management ::v-deep .el-pagination .btn-next {
  font-size: 10px !important;
  min-width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}

.order-management >>> .el-collapse-item,
.order-management ::v-deep .el-collapse-item {
  border-bottom: none !important;
}

.order-management >>> .el-collapse,
.order-management ::v-deep .el-collapse {
  border: none !important;
}

.order-management >>> .el-collapse-item__wrap,
.order-management ::v-deep .el-collapse-item__wrap {
  border-bottom: none !important;
}

.order-management >>> .el-collapse-item:last-child,
.order-management ::v-deep .el-collapse-item:last-child {
  margin-bottom: 0 !important;
}

.order-management >>> .el-collapse-item + .el-collapse-item,
.order-management ::v-deep .el-collapse-item + .el-collapse-item {
  margin-top: 0px !important;
}

.order-management >>> .el-collapse-item__arrow,
.order-management ::v-deep .el-collapse-item__arrow {
  margin: 0 1px !important;
  font-size: 8px !important;
}

.order-management >>> .el-empty,
.order-management ::v-deep .el-empty {
  font-size: 10px !important;
}

.order-management >>> .el-empty__description,
.order-management ::v-deep .el-empty__description {
  font-size: 10px !important;
}

.order-management >>> .el-loading-text,
.order-management ::v-deep .el-loading-text {
  font-size: 9px !important;
}

/* 页面加载状态 */
.page-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  padding: 15px;
}

.page-loading-content {
  text-align: center;
  color: #606266;
}

.page-loading-spinner {
  margin-bottom: 6px;
}

.page-loading-spinner i {
  font-size: 18px;
  color: #409eff;
  animation: rotating 2s linear infinite;
}

.page-loading-title {
  font-size: 12px;
  font-weight: 500;
  color: #303133;
  margin: 0 0 6px 0;
}

.page-loading-detail {
  font-size: 10px;
  color: #909399;
  margin: 0;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 布局样式 */

.main-tabs {
  flex: 1;
}

/* .tab-actions {
  display: flex;
  align-items: center;
  padding-bottom: 1px;
  position: fixed;
  top: 22px;
  right: 10px;
} */

.order-container {
  min-height: 150px;
}

.loading-container {
  text-align: center;
  padding: 15px;
  color: #909399;
  font-size: 9px;
}

.loading-container i {
  font-size: 16px;
  margin-bottom: 3px;
}

.empty-container {
  padding: 15px;
}

.pagination-container {
  margin-top: 8px;
  text-align: center;
}

/* 订单列表组件容器样式 */
.order-container {
  margin-bottom: 8px;
}

.api-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #e9ecef;
  border-bottom: 1px solid #dee2e6;
}

.api-info-header h4 {
  margin: 0;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
}

.api-info-content {
  padding: 16px;
}

.api-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.api-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
}

.api-label {
  color: #6c757d;
  font-weight: 500;
  min-width: 80px;
  flex-shrink: 0;
}

.api-value {
  color: #212529;
  flex: 1;
  word-break: break-all;
  font-family: "Consolas", "Monaco", monospace;
}

.api-params {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.api-params pre {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px;
  margin: 0;
  font-size: 12px;
  color: #495057;
  overflow-x: auto;
  flex: 1;
  font-family: "Consolas", "Monaco", monospace;
}

.copy-btn {
  padding: 2px 6px;
  color: #007bff;
  font-size: 10px;
  border-radius: 2px;
  background: transparent;
  flex-shrink: 0;
}

.copy-btn:hover {
  background: #007bff;
  color: white;
}

.page-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.page-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
}

.user-info {
  color: #606266;
  font-size: 14px;
}

.user-info span {
  margin-right: 20px;
}

.tabs-header {
  /* display: flex;
  justify-content: space-between;
  align-items: flex-end; */
  margin-top: 10px;
  gap: 10px;
}

.main-tabs {
  flex: 1;
}

.tab-actions {
  display: flex;
  align-items: center;
  padding-bottom: 1px; /* 与tabs底部对齐 */
}

.search-filters {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
}

.tab-content {
  padding: 40px;
  text-align: center;
  color: #909399;
  font-size: 16px;
}

.search-form {
  margin: 0;
}

.order-container {
  min-height: 200px;
}

.loading-container {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: 10px;
}

.loading-container i {
  font-size: 16px;
  margin-bottom: 5px;
}

.empty-container {
  padding: 20px;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* 订单相关样式已移至OrderList组件 */

.pagination-container {
  margin-top: 10px;
  text-align: center;
}

/* 预订单样式 */
.preorder-container {
  margin-top: 10px;
}

.preorder-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  color: #606266;
}

.preorder-loading i {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 8px;
  animation: rotating 2s linear infinite;
}

.preorder-empty {
  padding: 20px 0;
}

.preorder-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.preorder-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.preorder-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.preorder-card .order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #ebeef5;
}

.preorder-card .order-number {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
}

.preorder-card .order-content {
  padding: 12px;
}

.preorder-card-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.preorder-card .product-info {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.preorder-card .product-image {
  flex-shrink: 0;
  width: 66px;
  height: 66px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}

.preorder-card .product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preorder-goods-placeholder {
  font-size: 12px;
  color: #999;
}

.preorder-card .product-details {
  flex: 1;
  min-width: 0;
}

.preorder-card .product-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
}

.preorder-card .product-subtitle {
  font-size: 12px;
  color: #606266;
  margin-bottom: 6px;
  line-height: 1.4;
}

.preorder-card .product-sku {
  font-size: 12px;
  color: #606266;
  line-height: 1.5;
}

.preorder-card .product-sku .label {
  color: #909399;
}

.preorder-card .product-sku .value {
  color: #303133;
}

.preorder-info {
  background: #f9fafc;
  border: 1px dashed #ebeef5;
  border-radius: 6px;
  padding: 10px;
}

.preorder-info .info-row {
  display: flex;
  font-size: 12px;
  color: #606266;
  margin-bottom: 6px;
}

.preorder-info .info-row:last-child {
  margin-bottom: 0;
}

.preorder-info .label {
  width: 70px;
  color: #909399;
  flex-shrink: 0;
}

.preorder-info .value {
  flex: 1;
  color: #303133;
}

.preorder-actions {
  text-align: right;
  margin-top: 10px;
}
</style>
